import React, { useState, useEffect } from "react";

import axios from "axios";

import { withRouter, Link } from "react-router-dom";

import Layout from "../../components/Layout";

import { apiCRMv3 } from "../../services/api";

import Swal from "sweetalert2";
import { components } from "react-select";

const SocialNetworkListToApprove = (props) => {
	const [posts, setPosts] = useState([]);
	const [loaded, setLoaded] = useState(false);
	const [pages, setPages] = useState(0);
	const [actualPage, setActualPage] = useState(1);

	useEffect(function () {
		loadList(1);
	}, []);

	async function loadList(page) {
		setLoaded(false);
		const responseGetPosts = await apiCRMv3.get(
			`/social-network/to-approve?page=${page}`
		);
		setPosts(responseGetPosts.data.data.posts);
		setPages(responseGetPosts.data.data.totalPages);
		setActualPage(responseGetPosts.data.data.page);
		setLoaded(true);
	}

	async function handleApprove(post) {
		Swal.fire({
			title: `Tem certeza que deseja aprovar o post de ${post.author.name}?`,
			text: "Ficará visível para todos na rede social!",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Sim, quero aprovar!",
			cancelButtonText: "Cancelar",
		}).then(async (result) => {
			if (!result.value) {
				Swal.fire(
					"Cancelado!",
					"Nenhum post será aprovado.",
					"success"
				);
			} else {
				setLoaded(false);
				try {
					const responseApprovePost = await apiCRMv3.post(
						`/social-network/${post.id}/approve`
					);
					if (
						responseApprovePost.status === 200 &&
						responseApprovePost.data.data.approved
					) {
						loadList(actualPage);
						setLoaded(true);
					} else {
						throw "Error";
					}
				} catch (error) {
					console.log(error);
					setLoaded(true);
					Swal.fire({
						type: "error",
						title: "Oops...",
						text: "Tivemos um problema ao aprovar esse post. Contate o suporte!",
					});
				}
			}
		});
	}

	async function handleDelete(post) {
		Swal.fire({
			title: `Tem certeza que deseja excluir o post de ${post.author.name}?`,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#d33",
			cancelButtonColor: "#3085d6",
			confirmButtonText: "Sim, quero excluir!",
			cancelButtonText: "Cancelar",
		}).then(async (result) => {
			if (!result.value) {
				Swal.fire(
					"Cancelado!",
					"Nenhum post será excluido.",
					"success"
				);
			} else {
				setLoaded(false);
				try {
					const responseDeletePost = await apiCRMv3.delete(
						`/social-network/delete-admin/${post.id}`
					);
					if (responseDeletePost.status === 204) {
						Swal.fire(
							"Sucesso!",
							"Post excluido com sucesso.",
							"success"
						);
						loadList(actualPage);
						setLoaded(true);
					} else {
						throw "Error";
					}
				} catch (error) {
					console.log(error);
					setLoaded(true);
					Swal.fire({
						type: "error",
						title: "Oops...",
						text: "Tivemos um problema ao excluir esse post. Contate o suporte!",
					});
				}
			}
		});
	}

	return (
		<Layout menuActive="posts" pageTitle="Lista de Posts">
			<div className="row">
				<div className="col-xs-12">
					<div className="card">
						<div className="card-header">
							<div className="card-title">Lista de Posts</div>
							{/* <ul className="card-action">
								<li>
									<Link
										to="/posts/novo"
										className="btn btn-sm btn-success"
									>
										Novo <i className="fa fa-plus"></i>
									</Link>
								</li>
							</ul> */}
						</div>
						<div
							className={`card-body ${loaded ? "" : "__loading"}`}
						>
							<div className="loader-container text-center">
								<div className="icon">
									<div className="sk-wave">
										<div className="sk-rect sk-rect1"></div>
										<div className="sk-rect sk-rect2"></div>
										<div className="sk-rect sk-rect3"></div>
										<div className="sk-rect sk-rect4"></div>
										<div className="sk-rect sk-rect5"></div>
									</div>
								</div>
								<div className="title">Carregando</div>
							</div>

							<div className="row">
								<div className="col-xs-12">
									<table className="table table-striped table-bordered table-hover">
										<thead>
											<tr>
												<th>Autor</th>
												<th>Texto</th>
												<th>Imagem/Vídeo</th>
												<th>Opções</th>
											</tr>
										</thead>
										<tbody>
											{posts.map((post, index) => {
												return (
													<tr key={index}>
														<td>
															{post.author.name}
														</td>
														<td>{post.text}</td>
														<td>
															{post.attachments
																.length > 0 ? (
																post
																	.attachments[0]
																	.type ===
																	"video" ? (
																	<video
																		style={{
																			width: "100%",
																			height: "240px",
																		}}
																		controls
																	>
																		<source
																			src={`https://crm-imagens.s3.us-east-1.amazonaws.com/${post.attachments[0].s3Key}`}
																			type={
																				post
																					.attachments[0]
																					.mime
																			}
																		/>
																		Your
																		browser
																		does not
																		support
																		the
																		video
																		tag.
																	</video>
																) : (
																	<center>
																		<img
																			className="img-responsive"
																			style={{
																				width: "250px",
																			}}
																			alt="Imagem do post"
																			src={`https://crm-imagens.s3.us-east-1.amazonaws.com/${post.attachments[0].s3Key}`}
																		/>
																	</center>
																)
															) : (
																"Nenhum arquivo"
															)}
														</td>
														<td>
															<div className="col-xs-12">
																<div className="col-xs-12">
																	<button
																		className="btn btn-xs btn-success"
																		style={{
																			width: "100%",
																		}}
																		onClick={() =>
																			handleApprove(
																				post
																			)
																		}
																	>
																		Aprovar{" "}
																		<div className="icon fa fa-check"></div>
																	</button>
																</div>
																<div className="col-xs-12">
																	<button
																		className="btn btn-xs btn-danger"
																		style={{
																			width: "100%",
																		}}
																		onClick={() =>
																			handleDelete(
																				post
																			)
																		}
																	>
																		Excluir{" "}
																		<div className="icon fa fa-trash"></div>
																	</button>
																</div>
															</div>
														</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</div>
							</div>
							{pages !== 0 ? (
								<div className="row">
									<div className="col-xs-12">
										<ul className="pagination">
											{Array(pages)
												.fill()
												.map((_, page) => (
													<li
														className={
															page + 1 ===
																actualPage
																? "active"
																: ""
														}
													>
														<a
															href="#"
															onClick={(e) => {
																e.preventDefault();
																loadList(
																	page + 1
																);
															}}
														>
															{page + 1}
														</a>
													</li>
												))}
										</ul>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default withRouter(SocialNetworkListToApprove);
